import { combineReducers } from 'redux';
import { HYDRATE_EXPERIMENTS_FROM_SERVER_STORE } from 'client/actions/constants';
import { publishedExperiments } from './published-experiments-reducer';
import { computedExperiment } from './computed-experiment-reducer';
import { pageExperiment } from './page-experiment-reducer';
import { experimentPageContextReducer } from './experiment-page-context-reducer';
import { exposureRecordReducer } from './exposure-record-reducer';

const combinedReducer = combineReducers({
  published: publishedExperiments,
  computed: computedExperiment,
  page: pageExperiment,
  pageContext: experimentPageContextReducer,
  exposureRecord: exposureRecordReducer,
});

/**
 * Reducer combining all reducers related to AB-testing.
 * Handles HYDRATE_EXPERIMENTS_FROM_SERVER_STORE to bulk-replace the entire slice (used by the MCP tool result handler).
 *
 * @type {Function}
 */
export const experimentReducer = (state, action = {}) => {
  if (action.type === HYDRATE_EXPERIMENTS_FROM_SERVER_STORE) {
    return action.data;
  }
  return combinedReducer(state, action);
};
